import Taskicon from "../../images/job.png";
import ServiceIcons from "../../images/note-alt.png";
import EquipmentIcons from "../../images/hammer-drill.png";
import EmployeeIcons from "../../images/user-7.png";
import VehiclesIcons from "../../images/tractor-2.png";
import BuildingsIcons from "../../images/home-alt-1.png";




export const ComponetArray = [
    { id: 1, name: "Employee" , icon : EmployeeIcons },
    { id: 2, name: "Equipment" , icon:  EquipmentIcons },
    { id: 3, name: "Buildings" , icon : BuildingsIcons },
    { id: 4, name: "vehicles" , icon : VehiclesIcons },
    { id: 5, name: "Services" , icon: ServiceIcons  },
    { id: 6, name: "Tasks"  , icon : Taskicon},
  ];


